import { defineMessages } from 'react-intl';

export default defineMessages({
    tooltipDummy: {
        id: 'custom.products.CU.tooltip.Dummy',
        defaultMessage: 'Dummy'
    }
    
})